import React from 'react';

export function BrandMark({ size = 'md' }) {
  return <span className={`brand-mark brand-mark-${size}`} style={{ backgroundImage: 'url(/logo.png)' }} aria-hidden="true" />;
}

export default function Brand({ stacked = false, size = 'md' }) {
  return (
    <span className={`brand-lockup${stacked ? ' stacked' : ''}`}>
      <BrandMark size={size} />
      <span className="brand-wordmark">
        <span>Leave</span><span>NOW</span>
      </span>
    </span>
  );
}
